import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import {
  Button,
  Input,
  SVGIcon,
} from '@pearsontechnology/aero-components';

import { ModalContent, ModalActions } from 'components/Modal';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { getIcon, getColor } from 'Workspace/helpers';

import messages from './messages';
import {
  CoursewareList as ListWrapper,
  CoursewareListItem as ListItem,
} from './styles';

function CoursewareSelector({
  projectId,
  onNext,
  onDismiss,
  projectService,
  theme,
}) {
  const [coursewareList, setCoursewareList] = useState([]);
  const [coursewareFilterValue, setCoursewareFilterValue] = useState('');
  const [selectedCoursewareItem, setSelectedCoursewareItem] = useState(null);
  const [isDeployButtonDisabled, setIsDeployButtonDisabled] = useState(true);

  useEffect(() => {
    const getCoursewareList = async () => {
      if (!projectId) return;
      const projectActivityList = await projectService.getProjectActivityList(projectId, ['title', 'author']);
      projectActivityList.sort((a, b) =>
        new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt));
      setCoursewareList(projectActivityList);
    };
    getCoursewareList();
  }, [projectService, projectId]);

  const filterList = (value) => {
    if (!value) {
      return coursewareList;
    }

    const searchValue = value.toLowerCase();
    return coursewareList.filter((activity) =>
      activity.configFields.title.toLowerCase().indexOf(searchValue) >= 0
    );
  };

  const handleSearchInput = (event) => {
    setCoursewareFilterValue(event.target.value);
  };

  const selectCoursewareItem = (coursewareItem) => () => {
    setSelectedCoursewareItem(coursewareItem);
    setIsDeployButtonDisabled(false);
  };

  const filteredCoursewareList = filterList(coursewareFilterValue);

  return (
    <Fragment>
      <ModalContent unpadBottom>
        <Input.Search
          width={'100%'}
          onChange={handleSearchInput}
          placeholder={intl.formatMessage(messages.searchCourseware)}
          label={intl.formatMessage(messages.searchCourseware)}
        />
      </ModalContent>
      <ListWrapper>
        {filteredCoursewareList.map((activity) => (
          <ListItem
            key={activity.activityId}
            onClick={selectCoursewareItem(activity)}
            selected={selectedCoursewareItem && selectedCoursewareItem.activityId === activity.activityId}
          >
            <SVGIcon
              icon={getIcon(activity.plugin.type)}
              viewBox="0 0 24 24"
              fill={getColor(activity.plugin.type, theme)}
              width={{ width: '24px', height: '24px' }}
            />
            {activity.configFields.title}
          </ListItem>
        ))}
      </ListWrapper>
      <ModalActions scrim>
        <Button grey onClick={onDismiss}>{intl.formatMessage(messages.cancelButton)}</Button>
        <Button
          primary
          disabled={isDeployButtonDisabled}
          onClick={() => onNext(selectedCoursewareItem)}
        >
          {intl.formatMessage(messages.nextButton)}
        </Button>
      </ModalActions>
    </Fragment>
  );
}

CoursewareSelector.propTypes = {
  projectId: PropTypes.string,
  onNext: PropTypes.func,
  onDismiss: PropTypes.func,
  projectService: PropTypes.object,
  theme: PropTypes.object,
};

export default withTheme(CoursewareSelector);
